import React, { useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProgressbarForKypForm.css';

const ProgressbarForKypForm = ({ UserUploadedDocs }) => {
  const [progress, setProgress] = useState(0);
  const [kypCategories, setKypCategories] = useState([
    { label: 'Land Use Certificate', key: 'landUseDoc', completed: false },
    { label: 'Market Value Declaration', key: 'marketValue', completed: false },
    { label: 'Neighbour Details', key: 'neighbourDetails', completed: false },
    { label: 'Bank Loan', key: 'legalStatus', completed: false },
  ]);

  useEffect(() => {
    updateProgress();
  }, [UserUploadedDocs]);

  const updateProgress = () => {
    try {
      const updated = kypCategories.map(category => {
        let isComplete = false;

        switch (category.key) {
          case 'landUseDoc':
            isComplete = UserUploadedDocs?.landUseDoc?.length === 1;
            break;
          case 'marketValue':
            isComplete = UserUploadedDocs?.marketValue !== '';
            break;
          case 'neighbourDetails':
            isComplete = UserUploadedDocs?.neighbourDetails?.length > 0;
            break;
          case 'legalStatus':
            isComplete = UserUploadedDocs?.legalStatus === 'Approved';
            break;
          default:
            break;
        }

        return { ...category, completed: isComplete };
      });

      setKypCategories(updated);

      const completedCount = updated.filter(c => c.completed).length;
      const newProgress = (completedCount / updated.length) * 100;
      setProgress(newProgress);

    } catch (err) {
      console.error('Error calculating progress:', err);
    }
  };

  return (
    <div className="kyp-progress-container">
      <div className="row">
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-8">
              <div className="kyp-progress-bar ">
                <CircularProgressbar
                  value={progress}
                  text={`${Math.round(progress)}%`}
                  styles={buildStyles({
                    textSize: '16px',
                    pathColor: `rgba(31, 182, 166, ${progress / 100})`,
                    textColor: '#1f2937',
                    trailColor: '#d1d5db',
                  })}
                />
              </div>
            </div>
          </div>
          <div className="kyp-category-list">
            <div className="row">
              {kypCategories.map((cat, idx) => (
                <div className="col-md-6 mt-3">
                  <div key={idx} className="kyp-category-item">
                    <div
                      className={`kyp-category-icon ${cat.completed ? 'completed' : ''}`}
                      title={cat.completed ? 'Completed' : 'Incomplete'}>
                      {cat.completed && (
                        <svg width="14" height="12" viewBox="0 0 24 24">
                          <path fill="#fff" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                      )}
                    </div>
                    <span className="kyp-category-label">{cat.label}</span>
                  </div>
                </div>

              ))}
            </div>

          </div>
        </div>
        <div className="col-md-6">
          <div className="kyp-info-section">
            <h5 className="kyp-info-heading">Why Consider a Bank Loan for Your Property Purchase?</h5>
            <p className="kyp-info-text">
              Purchasing property is a significant financial commitment. A bank loan helps by spreading the cost over time,
              making it easier to acquire your dream property without needing the full amount upfront.
            </p>
          </div>
        </div>
      </div>


    </div>
  );
};

export default ProgressbarForKypForm;

